// The imports we need from both aws-sdk and the cognito js library
import {
  Config,
  CognitoIdentityCredentials
} from 'aws-sdk'
import {
  CognitoUser,
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js'

import config from '@/config'
import authService from "@/authService";
import Swal from 'sweetalert2';
import pingService from "@/pingService";

// We'll want to create a class for CognitoAuth which will
// contain all the methods we will need within our App
export default class CognitoAuth {
  // The constructor for this class will initialize our userSession
  // as null
  constructor() {
    this.userSession = null
  }

  // this will set up our app to use cognito to use
  // the user pool that we'll be creating later on
  configure(config) {
    if (typeof config !== 'object' || Array.isArray(config)) {
      throw new Error('[CognitoAuth error] valid option object required')
    }
    this.userPool = new CognitoUserPool({
      UserPoolId: config.IdentityPoolId,
      ClientId: config.ClientId
    })
    Config.region = config.region
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    })
    this.options = config

  }

  // a signup function which will allow new people
  // to create an account in our app
  signup(username, email, pass, cb) {
    let attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email
      })
    ]

    this.userPool.signUp(username, pass, attributeList, null, cb)

  }

  // a function that will allow existing users to
  // authenticate with our application
  authenticate(username, pass, cb) {
    let authenticationData = {
      Username: username,
      Password: pass
    }
    let authenticationDetails = new AuthenticationDetails(authenticationData)
    let userData = {
      Username: username,
      Pool: this.userPool
    }
    let cognitoUser = new CognitoUser(userData)

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        var logins = {}
        logins['cognito-idp.' + config.region + '.amazonaws.com/' + config.UserPoolId] = result.getIdToken().getJwtToken()

        Config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: config.UserPoolId,
          Logins: logins
        })
        console.log("onsuccess",result)
        cb(null, result)
      },
      onFailure: function (err) {
        console.log("onfailure",err)
        cb(err);
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        console.log('New Password Is Required', userAttributes, requiredAttributes, cognitoUser);
        window.location.href = '/reset?session=' + cognitoUser.Session + '&username=' + encodeURIComponent(cognitoUser.username);
      },
      mfaRequired: function(name,params) {
        console.log("mobile otp",name,params);
        let userPhoneNumber = params ? "("+params.CODE_DELIVERY_DESTINATION+")" : "";
        // console.log(window.$Sweetalert);
        let messgaeToUser = "We just sent an SMS authentication code to the phone number "+userPhoneNumber+" you provided"
        window.sweetalert.prompt(messgaeToUser).then(verificationCode =>{
          console.log("call")
          cognitoUser.sendMFACode(verificationCode, this);
        }).catch(() => {
          console.log("error");
          cognitoUser.sendMFACode("", this);

        })
        
        //cb(null, codeDeliveryDetails)
      },
      totpRequired: function(name,params) {
        console.log("App otp",name,params);
       // console.log(window.$Sweetalert);
       let messgaeToUser = "Enter Your Security Code"
       window.sweetalert.prompt(messgaeToUser).then(verificationCode =>{
        // console.log("call")
         cognitoUser.sendMFACode(verificationCode, this,"SOFTWARE_TOKEN_MFA");
       }).catch(() => {
         console.log("error");
         cognitoUser.sendMFACode("", this);

       })
       
       //cb(null, codeDeliveryDetails)
     },
     selectMFAType: function(challengeName, challengeParameters){
      Swal.fire({
        title: 'Select MFA method?',
        text: '',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'APP Authentication',
        cancelButtonText: 'SMS Authentication',
        
      }).then((result) => {
         if(result.value){
            cognitoUser.sendMFASelectionAnswer('SOFTWARE_TOKEN_MFA', this);            
         }
         if(result.dismiss){
            cognitoUser.sendMFASelectionAnswer('SMS_MFA', this);
         }
      })
      console.log(challengeName, challengeParameters);
      //cognitoUser.sendMFASelectionAnswer('SMS_MFA', this);
      },
      mfaSetup : function(challengeName, challengeParameters){
        Swal.fire({
          title: 'Select MFA method?',
          text: '',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'APP Authentication',
          cancelButtonText: 'SMS Authentication',
          
        }).then((result) => {
           if(result.value){
              cognitoUser.sendMFASelectionAnswer('SOFTWARE_TOKEN_MFA', this);            
           }
           if(result.dismiss){
              cognitoUser.sendMFASelectionAnswer('SMS_MFA', this);
           }
        })
        console.log(challengeName, challengeParameters);
        //cognitoUser.sendMFASelectionAnswer('SMS_MFA', this);
        },
    })

  }

  // a helper function that allows us to
  // get the information for the current user
  getCurrentUser() {
    return this.userPool.getCurrentUser()
  }

  // a function that allows us to confirm newly
  // registered users of our app
  confirmRegistration(username, code, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.confirmRegistration(code, true, cb)
  }
  //forgot password 
  forgotPassword(username, cb) {

    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.forgotPassword({
      onSuccess: function (result) {
        console.log('call result: ' + result);
        cb(null, result)
      },
      onFailure: function (err) {
        cb(err)
        //alert(err || JSON.stringify(err));
      }
    });
  }

  //confirmPassword password 
  confirmPassword(username, verificationCode, newPassword, cb) {

    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess: function (result) {
        console.log('call result: ' + result);
        cb(null, result)
      },
      onFailure: function (err) {
        cb(err)
        //alert(err || JSON.stringify(err));
      }
    });
  }


  // does what it says on the tin, allows users
  // to logout if they are already logged in
  logout() {
    // console.log("Current user",this.getCurrentUser());
    if(this.getCurrentUser()){
      this.getCurrentUser().signOut()
    }
    authService.removeOrgToken();
    authService.removeUser();
    authService.removeFcmToken();
    localStorage.removeItem("INVUPLOADSTATUS");
    localStorage.removeItem("SPREADUPLOADSTATUS");
    localStorage.removeItem("OFFERUPLOADSTATUS");
    localStorage.removeItem("ARBSUPLOADSTATUS");
    localStorage.removeItem("PLUPLOADSTATUS");
    localStorage.removeItem("userLastSeen");
    localStorage.removeItem("downloadedZipKeys");
    localStorage.removeItem("ARBSFEEDTYPE");
    pingService.stopTimer();
  }

  //passwordreset firstime
  passwordReset(session, username, password, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.Session = session
    cognitoUser.completeNewPasswordChallenge(
      password, {}, {
        onSuccess: (user) => {
          console.log('Password change', user);
          cb(null, user)

        },
        onFailure: (error) => {
          cb(error);
          console.log("Password change error", error);
        },
      },
    );
  }
  changePassword(oldPassword, newPassword) {
    var cognitoUser = this.getCurrentUser();
    //console.log(cognitoUser.getUserAttributes());
    this.getCurrentUser().getSession(function (err, data) {
      if (err) {
       // alert(err);
        return;
      } else {
        console.log("data", data)
      }
    });
    cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
      if (err) {
        alert(err.message || JSON.stringify(err));
        return;
      }
      console.log('call result: ' + result);
    });
  }

  // Retrieve the users current token if they have
  // a session, otherwise returns null
  getIdToken(cb) {
    if (this.getCurrentUser() == null) {
      return cb(null, null)
    }
    this.getCurrentUser().getSession((err, session) => {
      if (err) return cb(err)
      if (session.isValid()) {
        return cb(null, session.getIdToken().getJwtToken())
      }
      cb(Error('Session is invalid'))
    })
  }

  // Retrieve the users current group
  // a session, otherwise returns null
  getUserGroup(cb) {

    if (this.getCurrentUser() == null) {
      return cb(null, null)
    }
    this.getCurrentUser().getSession((err, session) => {
      if (err) return cb(err)
      if (session.isValid()) {
        return cb(null, session.getIdToken().payload['cognito:groups'])
      }
      cb(Error('Session is invalid'))
    })
  }
  getUserRoles(cb){
    if (this.getCurrentUser() == null) {
      return cb(null, null)
    }
    this.getCurrentUser().getSession((err, session) => {
      if (err) return cb(err)
      if (session.isValid()) {
        let groups = session.getIdToken().payload['cognito:groups'];
        let roles = groups.map(item => {return  item.split("-")[1]});
        let returnObj = {
          isAdmin : roles.includes('Admin') ? true : false,
          isEditor  : roles.includes('Editor') ? true : false,
          isTrader  : roles.includes('Trader') ? true : false,
          isSuperAdmin : roles.includes('SuperAdmin') ? true : false
        }
        return cb(null, returnObj)
      }
      cb(Error('Session is invalid'))
    })
  }


  isAuthenticated(cb) {
    let cognitoUser = this.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return cb(err, false)
        }
        return cb(session, true)
      })
    } else {
      cb(null, false)
    }
  }
}

// This installed CognitoAuth into our Vue instance
CognitoAuth.install = function (Vue, options) {
  Object.defineProperty(Vue.prototype, '$cognitoAuth', {
    get() {
      return this.$root._cognitoAuth
    }
  })

  Vue.mixin({
    beforeCreate() {
      if (this.$options.cognitoAuth) {
        this._cognitoAuth = this.$options.cognitoAuth
        this._cognitoAuth.configure(options)
      }
    }
  })
}